import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { FilteringRuleSliceDTO } from './types'

export const FILTERING_RULE_FRAGMENT_FOR_CREATE: TypedDocumentNode<FilteringRuleSliceDTO> = gql`
  fragment FilteringRuleFragmentForCreate on FilteringRule {
    id
    name
  }
`
